import React, { useState, useRef, useContext, useEffect } from "react";
import { ManageMapperLayout } from "../../../components";
import { Button, Modal } from "react-bootstrap";

import { Form } from "react-bootstrap";
import FileInfo from "./FileInfo";
import APIInfo from "./APIInfo";
import {
  getPathWithParam,
  MANAGE_MAPPER_ROUTES,
  manageMapperFormNames,
  mapperFormFields,
  FLOW_TYPES,
  ROUTES,
  sourceTypeData,
} from "../../../utils";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import {
  manageMapperStore,
  UploadSourceFile,
  setManageMapperToastInfo,
  setManageMapperPageLevelData,
  setMapperPageLevelData,
  MANAGE_MAPPER_POST_API_ERROR,
} from "../../../contexts";
import {
  FieldDropSide,
  SearchableList,
  LoaderWrapper,
} from "../../../components";
import { Field, Formik } from "formik";
import { get, isEmpty, isNull } from "lodash";
import * as Yup from "yup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";

const initialValues = {};

const SourceContainer = (props) => {
  const [newFile, setNewFile] = useState([]);
  const [allowEmptyInputFile, setAllowEmptyInputFile] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { state, dispatch } = useContext(manageMapperStore);

  const fileName =
    get(state, "api.fileuploadData.mappingConfiguration.fileName") ||
    get(state, "api.data.fileName");
  const basicInformationDetails = {
    name: get(state, "api.data.name", ""),
    mapType: get(state, "api.data.isOutput", ""),
    planProfileMappings: get(state, "api.data.planProfiles", []),
  };
  const basicInformation = isEdit
    ? get(state, "basicInformation", [])
    : basicInformationDetails;
  const configuration = isEmpty(
    get(state, "api.fileuploadData.mappingConfiguration", {})
  )
    ? get(state, "api.data", {})
    : get(state, "api.fileuploadData.mappingConfiguration", {});
  const formValues = !get(state, "api.fileuploadData")
    ? get(state, "api.data", {})
    : configuration;
  const [previousFile, setPreviousFile] = useState("");
  const [isSubmitsucces, setIsSubmitsucces] = useState(null);
  const formName = manageMapperFormNames.SOURCE;
  const fields = mapperFormFields[formName];
  const [dataLoading, setDataLoading] = useState(false);
  const editable = formValues.step ? true : false;
  const config = !isEmpty(formValues)
    ? JSON.parse(get(formValues, "configurationJson", null))
    : "";
  const ftpDetails = !isEmpty(formValues)
    ? get(formValues, "redirectFTP", null)
    : "";
  const [isResponseFailed, setIsResponseFailed] = useState(true);

  const apiFormat = get(state, "api.data.format", []);

  const uploadFormat = get(
    state,
    "api.fileuploadData.mappingConfiguration.format",
    []
  );
  const fileFormatCheck = () => {
    if (!isEmpty(get(state, "api.fileuploadData", [])) && isResponseFailed) {
      return uploadFormat;
    } else if (
      isEmpty(get(state, "api.fileuploadData", [])) &&
      isResponseFailed
    ) {
      if (
        !isEmpty(
          get(state, "api.fileuploadData.mappingConfiguration.format", [])
        )
      ) {
        return uploadFormat;
      } else {
        return apiFormat;
      }
    } else if (
      !isEmpty(get(state, "api.fileuploadData", [])) &&
      !isResponseFailed
    ) {
      return uploadFormat;
    } else {
      return apiFormat;
    }
  };
  const stepCheck = get(formValues, "step") == 0;
  const { flow, profileId, mapType } = useRouterParams();
  const isEdit = flow === FLOW_TYPES.EDIT;
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.MAPPER_HOME,
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
      //link: isEdit ? `${MANAGE_MAPPER_ROUTES.FILTER}/edit/${profileId}`: `${MANAGE_MAPPER_ROUTES.FILTER}/${profileId}`
    },
  ];
  const [fileUploadRequired, setFileUploadRequired] = useState("");
  const [clearField, setClearField] = useState(false);
  const [uploadSourceFile, setUploadSourceFile] = useState();
  useDeepEffect(() => {
    if (!isEmpty(fileName) && !isEmpty(newFile)) {
      setIsModalOpen(true);
    }
  }, [newFile]);

  const onDeleteConfirmClick = () => {
    setIsModalOpen(false);
  };

  const handleClose = () => {
    setClearField(true);
    setIsModalOpen(false);
  };
  const showError = (values) => {
    const filenameArray = values[fields.uploadSourceFile]
      ? values[fields.uploadSourceFile][0].name.split(".")
      : get(state, "api.data.fileName").split(".");
    switch (values[fields.fileFormat]) {
      case 1:
        if (values[fields.uploadSourceFile][0].name.split(".")[1] != "csv") {
          setFileUploadRequired("*Please upload a valid csv file.");
        }
        break;
      case 2:
        if (
          filenameArray[filenameArray.length - 1] != "txt" &&
          filenameArray[filenameArray.length - 1] != "yaml"
        ) {
          setFileUploadRequired("*Please upload a valid text file.");
        }
        break;
      case 3:
        if (
          filenameArray[filenameArray.length - 1] != "xlsx" &&
          filenameArray[filenameArray.length - 1] != "xls"
        ) {
          setFileUploadRequired("*Please upload a valid excel file.");
        }
        // else if (filenameArray[filenameArray.length - 1] == "docx"){
        //   setFileUploadRequired("*Invalid file format");
        // }
        break;
      default:
        setFileUploadRequired("*Please upload a valid excel/csv file.");
        break;
    }
  };
  const onFormSubmit = (values) => {
    const { history } = props;
    const configure =
      values[fields.fileFormat] === 1
        ? {
            delimiter: values[fields.delimiter],
            commentCharacter: "#",
            headerRow: values[fields.contentStartsFrom],
            hasHeader: values[fields.hasHeader],
            allowNull: values[fields.checkForHeaderCountMismatch],
          }
        : values[fields.fileFormat] === 3
        ? {
            spreadSheetToRead: values[fields.selectDataFrom],
            spreadSheetName: values[fields.spreadSheetName].trim(),
            headerRow: values[fields.contentStartsFrom],
            hasHeader: values[fields.hasHeader],
            allowNull: values[fields.checkForHeaderCountMismatch],
            spreadSheetNumber: values[fields.spreadSheetNumber],
          }
        : {
            recordLength: values[fields.recordLength],
          };
    setDataLoading(true);
    if (isEmpty(fileName) && isEmpty(values[fields.uploadSourceFile])) {
      setFileUploadRequired(
        "Required . Please upload a file in order to create a profile."
      );
      setDataLoading(false);
    } else if (!isEmpty(fileName) && isEmpty(values[fields.uploadSourceFile])) {
      if (!fileUploadRequired) {
        if (state.mapType == 3) {
          history.push(
            getPathWithParam({
              path: MANAGE_MAPPER_ROUTES.PREVIEW,
              pathParam: [FLOW_TYPES.EDIT, mapType, profileId],
            })
          );
        } else {
          history.push(
            values[fields.fileFormat] === 2
              ? history.push(
                  `${MANAGE_MAPPER_ROUTES.FIXED_LENGTH}/${
                    isEdit ? "edit" : null
                  }/${mapType}/${profileId}`
                )
              : getPathWithParam({
                  path: MANAGE_MAPPER_ROUTES.TARGET,
                  pathParam: [FLOW_TYPES.EDIT, mapType, profileId],
                })
          );
        }
      }
    } else if (!isEmpty(values[fields.uploadSourceFile])) {
      UploadSourceFile({ values, basicInformation, configure }, dispatch, state)
        .then((res) => {
          setFileUploadRequired(res.errormessage ? res.errormessage : "");
          if (res.isSuccess) {
            // const newProfileId = get(res, "id");
            const newProfileId = get(state, "api.data.id");
            if (!isEdit) {
              dispatch(
                setMapperPageLevelData({
                  formName: formName,
                  fieldData: values,
                  format: values[fields.fileFormat],
                })
              );
            }
            dispatch(
              setManageMapperPageLevelData({
                formName: "objectMaps",
                fieldData: get(res, "mappingConfiguration.objectMaps", []),
              })
            );
            dispatch(
              setManageMapperToastInfo({
                showToast: true,
                toastMessage: "Data saved successfully",
              })
            );
            window.setTimeout(() => {
              if (state.mapType == 3) {
                history.push(
                  values[fields.fileFormat] === 2
                    ? history.push(
                        `${MANAGE_MAPPER_ROUTES.FIXED_LENGTH}/${mapType}/${newProfileId}`
                      )
                    : getPathWithParam({
                        path: MANAGE_MAPPER_ROUTES.PREVIEW,
                        pathParam: [FLOW_TYPES.ADD, mapType, newProfileId],
                      })
                );
              } else {
                history.push(
                  values[fields.fileFormat] === 2
                    ? history.push(
                        `${MANAGE_MAPPER_ROUTES.FIXED_LENGTH}/${mapType}/${newProfileId}`
                      )
                    : getPathWithParam({
                        path: MANAGE_MAPPER_ROUTES.TARGET,
                        pathParam: [FLOW_TYPES.ADD, mapType, newProfileId],
                      })
                );
              }
            }, 10);
            setDataLoading(false);
          } else {
            setIsSubmitsucces(false);
            showError(values);
            setIsResponseFailed(false);
            dispatch({
              type: MANAGE_MAPPER_POST_API_ERROR,
              payload: "Something went wrong! please try again.",
            });
            setDataLoading(false);
          }
        })
        .catch((err) => {
          dispatch({
            type: MANAGE_MAPPER_POST_API_ERROR,
            payload: "Something went wrong! please try again.",
          });
          setDataLoading(false);
        });
    } else {
      showError(values);
    }
  };

  const ValidationSchema = Yup.object().shape({
    sourceUrl: Yup.string().when("fileType", {
      is: 2,
      then: Yup.string().required("URL Required"),
    }),
    delimiter: Yup.string().when("format", {
      is: 1,
      then: Yup.string().required("Required"),
    }),
    sourceUserName: Yup.string().when("fileType", {
      is: 2,
      then: Yup.string().required("Username Required"),
    }),
    sourcePassword: Yup.string().when("fileType", {
      is: 2,
      then: Yup.string().required("Password Required"),
    }),
    spreadSheetNumber: Yup.string().when("selectDataFrom", {
      is: 3,
      then: Yup.string()
        .required("Required")
        .test(
          "Is positive?",
          "The number must be greater than 0",
          (value) => value > 0
        ),
    }),
    spreadSheetName: Yup.string().when("selectDataFrom", {
      is: 4,
      then: Yup.string().required("Required"),
    }),
    contentStartsFrom: Yup.string()
      .required("Required")
      .test(
        "Is positive?",
        "The number must be greater than 0",
        (value) => value > 0
      ),
  });

  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...formValues,
        uploadSourceFile: uploadSourceFile,
        mapType: mapType,
        [fields.allowEmptyInputFile]: get(
          configuration,
          "allowEmptyInputFile",
          false
        ),
        [fields.fileType]: 1,
        [fields.fileFormat]: stepCheck ? 3 : fileFormatCheck(),
        [fields.selectDataFrom]: get(config, "spreadSheetToRead", 1),
        [fields.hasHeader]: get(config, "hasHeader", true),
        [fields.checkForHeaderCountMismatch]: true,
        [fields.contentStartsFrom]: get(config, "headerRow", 1),
        [fields.spreadSheetName]: isNull(get(config, "spreadSheetName", ""))
          ? ""
          : get(config, "spreadSheetName", ""),
        [fields.spreadSheetNumber]: isNull(get(config, "spreadSheetNumber", 1))
          ? ""
          : get(config, "spreadSheetNumber", 1),
        [fields.delimiter]: get(config, "delimiter", ","),
        [fields.requireFtp]: get(formValues, "isSFTPDetails", false),
        [fields.ftpUrl]: get(ftpDetails, "sftpHost", null),
        [fields.ftpPath]: get(ftpDetails, "sftpPath", null),
        [fields.username]: get(ftpDetails, "sftpUserName", null),
        [fields.password]: get(ftpDetails, "sftpPassword", null),
        [fields.recordLength]: get(config, "recordLength", 0),
      }}
      enableReinitialize
      onSubmit={onFormSubmit}
      validationSchema={ValidationSchema}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        errors,
        values,
        touched,
        setValues,
        handleChange,
        setFieldValue,
        handleSubmit,
      }) => {
        const clearFiles = () => {
          setFieldValue(fields.uploadSourceFile, undefined);
          setNewFile([]);
        };
        return (
          <Form autoComplete="off" className="h-100" onSubmit={handleSubmit}>
            <LoaderWrapper isLoading={dataLoading}>
              <ManageMapperLayout layoutHeader="Source" buttons={buttons}>
                {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                <div style={{ fontSize: "18px", fontWeight: "600" }}></div>

                <div style={{ width: "320px" }}>
                  {mapType != 3 && (
                    <Field
                      name={fields.fileType}
                      label={"Type"}
                      value={values[fields.fileType]}
                      options={sourceTypeData}
                      isRequired
                      direction={"bottom"}
                      //disabled={isEdit || !isEmpty(get(state, formName, []))}
                      //disabled={editable}
                      popupContent={
                        <SearchableList
                          label={"Source Type"}
                          isNotTypeAhead
                          options={sourceTypeData}
                          onSelect={(value) =>
                            setFieldValue(fields.fileType, value)
                          }
                          selectedValue={values[fields.fileType]}
                        />
                      }
                      component={FieldDropSide}
                    />
                  )}
                  <div style={{ marginTop: "20px" }}>
                    {(() => {
                      if (values[fields.fileType] == 1) {
                        return (
                          <div>
                            <FileInfo
                              handleChange={handleChange}
                              values={values}
                              isSubmitsucces={isSubmitsucces}
                              previousFile={previousFile}
                              setPreviousFile={setPreviousFile}
                              setFileUploadRequired={setFileUploadRequired}
                              setFieldValue={setFieldValue}
                              fields={fields}
                              isEdit={isEdit}
                              editable={editable}
                              newFile={newFile}
                              fileName={fileName}
                              setNewFile={setNewFile}
                              clearField={clearField}
                              setClearField={setClearField}
                              fileUploadRequired={fileUploadRequired}
                              state={state}
                              formName={formName}
                              allowEmptyInputFile={allowEmptyInputFile}
                              setAllowEmptyInputFile={setAllowEmptyInputFile}
                            />
                          </div>
                        );
                      } else if (values[fields.fileType] == 2) {
                        return (
                          <APIInfo
                            values={values}
                            editable={editable}
                            setFieldValue={setFieldValue}
                            fields={fields}
                          />
                        );
                      }
                    })()}
                  </div>
                </div>

                <Modal show={isModalOpen} onHide={handleClose}>
                  <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                    <div className="text-right">
                      <FontAwesomeIcon
                        icon={faTimes}
                        color="#000"
                        onClick={() => setIsModalOpen(false)}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="pd-15">
                        <FontAwesomeIcon
                          icon={faExclamationTriangle}
                          color="#f94f50"
                          size="3x"
                        />
                      </div>
                      <div className="remove-text">
                        <h4>New File Detected </h4>
                        <p>
                          Are you sure ? Some of your mapped fields will be
                          deleted.. Do you want to continue ?
                        </p>

                        <Button
                          className="remove-btn mr-4"
                          onClick={onDeleteConfirmClick}
                        >
                          Yes
                        </Button>
                        <Button
                          className="cancel-btn"
                          onClick={() => {
                            handleClose();
                            clearFiles();
                          }}
                        >
                          No
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </ManageMapperLayout>
            </LoaderWrapper>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SourceContainer;
